const debugInfoSymbol = Symbol('DEBUG_INFO');

interface DebugInfo<D> {
  [debugInfoSymbol]: D;
}

export type WithDebugInfo<T, D> = T | (T & DebugInfo<D>);

export function withDebugInfo<T extends object, D>(response: T, debugInfo: D): T & DebugInfo<D> {
  Object.defineProperty(response, debugInfoSymbol, {
    enumerable: true,
    value: debugInfo,
  });
  return response as any;
}

export function getDebugInfo<T, D>(obj: WithDebugInfo<T, D>): D | undefined {
  return obj[debugInfoSymbol];
}
